<div class="esf-overlay -is-open" *ngIf="!spinnerService.isShowing(spinner)">
  <div class="esf-modal -is-open">
    <header class="esf-modal__header">
      <h3 i18n='@@tixxSelect.modalTitle.createNewOrderList'>Create new Tixx-Select event</h3>
    </header>
    <div class="esf-modal__inner">
      <div app-form-field-select
           [array]="availableTixxEvents"
           [placeholderText]="flTranslations.i18nSelectAnEvent"
           [valueKey]="'id'"
           [textKey]="'summary'"
           [id]="'eventDetails'"
           [label]="flTranslations.i18nGetEventDetailsFromTixx"
           (valueChanged)="selectTixxEvent($event)">
      </div>

      <ng-container *ngIf="selectedEvent">

        <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
          <span class="esf-action-heading__text" i18n='Section title@@tixxSelect.heading.eventDetails'>Event details</span>
        </h4>

        <form [formGroup]="createOrderListForm" (ngSubmit)="submitTixxEvent()" id="createOrderListForm">
          <div app-form-field-select
               [control]="createOrderListForm.get('type')"
               [label]="flTranslations.i18nEventType"
               [valueKey]="'eventTypeId'"
               [textKey]="'name'"
               [array]="tixxEventTypes">
          </div>

          <div class="esf-form-group">
            <div app-form-field-text-generic
                 class="esf-form-item--1-2"
                 [control]="createOrderListForm.get('name')"
                 [placeholder]="flTranslations.i18nTitle"
                 [label]="flTranslations.i18nTitle">
            </div>
            <div app-form-field-datepicker
                 class="esf-form-item--1-2"
                 [enableTime]="true"
                 [control]="createOrderListForm.get('date')"
                 [placeholder]="flTranslations.i18nEventDate"
                 [label]="flTranslations.i18nEventDate">
            </div>
          </div>

          <div class="esf-form-group">
            <div app-form-field-text-generic
                 class="esf-form-item--1-2"
                 [control]="createOrderListForm.get('homeTeam')"
                 [placeholder]="flTranslations.i18nHomeTeam"
                 [label]="flTranslations.i18nHomeTeam">
            </div>
            <div app-form-field-text-generic
                 class="esf-form-item--1-2"
                 [control]="createOrderListForm.get('guestTeam')"
                 [placeholder]="flTranslations.i18nGuestTeam"
                 [label]="flTranslations.i18nGuestTeam">
            </div>
          </div>

          <div class="esf-form-group">
            <div app-form-field-text-generic
                 class="esf-form-item--1-2"
                 [control]="createOrderListForm.get('competition')"
                 [placeholder]="flTranslations.i18nCompetition"
                 [label]="flTranslations.i18nCompetition">
            </div>
            <div app-form-field-text-generic
                 class="esf-form-item--1-2"
                 [control]="createOrderListForm.get('venue')"
                 [placeholder]="flTranslations.i18nVenue"
                 [label]="flTranslations.i18nVenue">
            </div>
          </div>
        </form>
      </ng-container>

    </div>
    <footer class="esf-modal__footer">
      <div class="esf-submit-row">
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--filled" form='createOrderListForm'>{{ btnTranslations.i18nCreate }}</button>
        </div>
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--outlined" (click)="closeModal()">{{ btnTranslations.i18nCancel }}</button>
        </div>
      </div>
    </footer>
    <div class="esf-modal__close" (click)="closeModal()">
      <svg class="esf-icon esf-icon--darker" width="24" height="24">
        <use xlink:href="#esf-icon-close"></use>
      </svg>
    </div>
  </div>
</div>
